import Phaser from 'phaser';

export default class MouseTracker {
  constructor() {
    this.coordinates = null;
    this.maxCoordinates = null;
    this.speed = null;
    this.angle = null;
    this.coordinates = [];
    this.maxCoordinates = 8;
  }

  reset (x,y) {
    this.coordinates = [];
    for (let i = 0; i < this.maxCoordinates; i++) {
      this.coordinates.push([x,y]);
    }
  }

  addPoint (x,y) {
    this.coordinates.unshift([x,y]);
    if (this.coordinates.length > this.maxCoordinates) {
      this.coordinates.pop();
    }
  }

  setVelocityOn (v) {
    // get dist from first to last
    const vx = this.coordinates[0][0] - this.coordinates[this.coordinates.length - 1][0];
    const vy = this.coordinates[0][1] - this.coordinates[this.coordinates.length - 1][1];
    // eslint-disable-next-line no-param-reassign
    v.x = vx * 5;
    // eslint-disable-next-line no-param-reassign
    v.y = vy * 5;
    return Phaser.Math.Distance.Between(this.coordinates[0][0], this.coordinates[0][1],this.coordinates[this.coordinates.length - 1][0],this.coordinates[this.coordinates.length - 1][1]);
  }
}